export const InsuranceCompanyOfferContent = (data) => {
  const brRegExp = new RegExp('<br />|<br/>', 'gm');

  const header = {
    headline: `${data?.headerHeadline || ''}`.replace(brRegExp, '\n'),
    subline: `${data?.headerSubline || ''}`.replace(brRegExp, '\n'),
    logo: data?.headerLogoUrl || null,
    logoHref: null
  };

  const courseInfo = {
    headline: `${data?.courseinfoHeadline || ''}`.replace(brRegExp, '\n'),
    illustration: data?.courseinfoIllustrationUrl || null,
    description: (data?.courseinfoDescription || '')
      .split('\n')
      .map((item) => item.trim())
      .filter(Boolean),
    checkmarks: (data?.courseinfoChecklist || '')
      .split(new RegExp('\r\n\r\n|\n\n', 'gm'))
      .map((item) => item.trim())
      .filter(Boolean)
  };

  const howTo = {
    headline: `${data?.howtoHeadline || ''}`.replace(brRegExp, '\n'),
    sections: [data?.howtoText1, data?.howtoText2, data?.howtoText3].filter(Boolean)
  };

  const form = {
    headline: `${data?.formHeadline || ''}`.replace(brRegExp, '\n'),
    description: data?.formDescription || ''
  };

  const formFields = {
    ...parseFormFields(data?.formFieldsAvailable || [], data?.formFieldsRequired || []),
    ...parseFormFields(data?.additionalConsentChecks || [], data?.additionalConsentChecks || [])
  };
  const optionalFields = {};
  Object.keys(formFields).forEach((field) => {
    if (!formFields[field].required) {
      optionalFields[field] = true;
    }
  });

  return {
    header,
    howTo,
    courseInfo,
    form,
    formFields,
    optionalFields
  };
};

const toCamelCase = (str) => str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));

const parseFormFields = (fields, requiredFields) => {
  const _formFields = {};
  fields.forEach((fieldName) => {
    let required = false;
    if (requiredFields.some((requiredField) => requiredField.startsWith(fieldName))) {
      required = true;
    }
    const name = toCamelCase(fieldName);
    _formFields[name] = {
      name: name,
      required: required
    };
  });
  return _formFields;
};
